//@ts-nocheck
import { useContext } from 'react';
import ActionsContext from './ActionsContext';

export default function useActions() : IActionsContext {

    const context : IActionsContext = useContext(ActionsContext);
    return context;
}